// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import { api } from './axios'
import Vuelidate from 'vuelidate'
import vSelect from 'vue-select'
import AsyncMethods from 'vue-async-methods'
import moment from 'vue-moment'
import { vSelectField, vTextField, vInputTime, vInputDate, vInputDateRange, vInputLocation, vInputTravelAgent, threlsIcon } from './components/Common'
import VueQuillEditor from 'vue-quill-editor'
import editorOptions from '@/editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor, editorOptions)

Vue.use(AsyncMethods)

Vue.use(Vuelidate)

Vue.use(BootstrapVue)

Vue.use(moment)

Vue.component('select2', vSelect)

Vue.component('vSelectField', vSelectField)
Vue.component('vTextField', vTextField)
Vue.component('vInputTime', vInputTime)
Vue.component('vInputDate', vInputDate)
Vue.component('vInputDateRange', vInputDateRange)
Vue.component('vInputLocation', vInputLocation)
Vue.component('vInputTravelAgent', vInputTravelAgent)
Vue.component('threlsIcon', threlsIcon)

Vue.prototype.$axios = api

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js